export const validateNifNIE = (value: string) => {
  value = value.toUpperCase();
  const letras = "TRWAGMYFPDXBNJZSQVHLCKE";

  // NIF estándar (8 números + 1 letra) 
  if (/^[0-9]{8}[A-Z]$/.test(value)) { 
    const numero = parseInt(value.slice(0, 8), 10); 
    const letra = value[8]; 
    return letra === letras[numero % 23]; 
  }

  // NIE (X, Y, Z seguido de 7 números y una letra) 
  if (/^[XYZ][0-9]{7}[A-Z]$/.test(value)) { 
    const reemplazo: any = { X: "0", Y: "1", Z: "2" }; 
    const numero = reemplazo[value[0]] + value.slice(1, 8); 
    const letra = value[8]; 
    return letra === letras[parseInt(numero, 10) % 23]; 
  }

  // NIE especial (T seguido de 8 dígitos)
  if (/^T[0-9]{8}$/.test(value)) {
    return true;
  }

  return false;
};

export const validateCifNif = (cif: string) => {
  const letras = "TRWAGMYFPDXBNJZSQVHLCKE";

  // NIF estándar (8 números + 1 letra) 
  if (/^[0-9]{8}[A-Z]$/.test(cif)) { 
    const numero = parseInt(cif.slice(0, 8), 10); 
    const letra = cif[8]; 
    return letra === letras[numero % 23]; 
  }

  //Quitamos el primer caracter y el ultimo digito
  // var valueCif = cif.substr(1, cif.length - 2);
  var valueCif = cif.split('').slice(1, -1).join('');
  var suma = 0;
  var suma2 = 0;

  //Sumamos las cifras pares de la cadena
  for (let i = 1; i < valueCif.length; i = i + 2) {
    suma = suma + parseInt(valueCif.substr(i, 1));
  }

  //Sumamos las cifras impares de la cadena
  for (let i = 0; i < valueCif.length; i = i + 2) {
    let result: number = parseInt(valueCif.substr(i, 1)) * 2;
    if (String(result).length === 1) {
      // Un solo caracter
      suma2 = suma2 + result;
    } else {
      // Dos caracteres. Los sumamos...
      suma2 = suma2 + parseInt(String(result).substr(0, 1)) + parseInt(String(result).substr(1, 1));
    }
  }

  // Sumamos las dos sumas que hemos realizado
  suma = suma + suma2;

  let unidad: number = suma % 10;
  unidad = 10 - unidad;

  var primerCaracter = cif.substring(0, 1).toUpperCase();

  if (primerCaracter.match(/^[FJKNPQRSUVW]$/)) {
    //Empieza por .... Comparamos la ultima letra
    if (String.fromCharCode(64 + unidad).toUpperCase() === cif.substr(cif.length - 1, 1).toUpperCase())
      return true;
  } else if (primerCaracter.match(/^[XYZ]$/)) {
    //Se valida como un nie
    let newcif = "";
    if (primerCaracter === "X") 
        newcif = "0" + cif.slice(1);
    else if (primerCaracter === "Y")
      newcif = "1" + cif.slice(1);
    else if (primerCaracter === "Z")
      newcif = "2" + cif.slice(1);
    return validateDNI(newcif);
  } else if (primerCaracter.match(/^[ABCDEFGHLMUVJ]$/)) {
    //Se revisa que el ultimo valor coincida con el calculo
    if (unidad === 10)
      unidad = 0;
    if (cif.substr(cif.length - 1, 1) === String(unidad))
      return true;
  } else {
    //Se valida como un dni
    return validateDNI(cif);
  }
  return false;
};


export function validateDNI(value: string) {
  if (value) {
    const dniRegex = /^(\d{8})([A-Z])$/;
    const matches = value.match(dniRegex);
    if (matches) {
      const dniNumbers = matches[1];
      const dniLetter = matches[2];
      const letters = "TRWAGMYFPDXBNJZSQVHLCKE";
      const index = parseInt(dniNumbers, 10) % 23;
      return letters.charAt(index) === dniLetter.toUpperCase();
    }
  }
};


export function validateSS(numeroSS: string): boolean {
  // Quitar cualquier espacio en blanco
  const cleanNum = numeroSS.replace(/\s/g, '');

  // Verificar que tiene exactamente 12 dígitos
  if (!/^\d{12}$/.test(cleanNum)) {
    return false;
  }

  // Extraer los 10 primeros dígitos y los 2 dígitos de control
  const baseNum = cleanNum.slice(0, 10);
  const controlDigits = cleanNum.slice(10);

  // El número base debe estar entre 0 y 9999999999 (10 dígitos)
  const baseNumInt = parseInt(baseNum, 10);
  if (baseNumInt < 0 || baseNumInt > 9999999999) {
    return false;
  }

  // El dígito de control se calcula dividiendo por 97 y tomando el resto
  const calculateControl = ('0' + (baseNumInt % 97)).slice(-2);

  // Verificar que el dígito de control coincide con el calculado
  return calculateControl === controlDigits;
};

export function validateNotWhitespace(value: string) {
  if (value && value.trim() === '') {
    return false;
  }
  return true;
};